import { calculateZoom } from '../utils/zoom_metadata'

/** Used by LiveView `push_event(..., "segment_identify_enrollment", ...)` and AnalyticsIdentify. */
export function convertMapKeysFromSnakeToCamelCase(object) {
  return Object.keys(object).reduce((acc, snakeCaseKey) => {
    if (object[snakeCaseKey] !== null) {
      const camelCaseKey = snakeCaseKey
        .toLowerCase()
        .replace(/([_][a-z])/g, str => str.toUpperCase().replace('_', ''))
      return { ...acc, [camelCaseKey]: object[snakeCaseKey] }
    } else {
      return acc
    }
  }, {})
}

export const AnalyticsClick = {
  mounted() {
    this.el.addEventListener('click', this.track)
  },
  destroyed() {
    this.el.removeEventListener('click', this.track)
  },
  track(e) {
    let eventName = this.dataset.analyticsEvent.trim()
    eventName = toCapitalCase(eventName)

    let metadata = this.dataset.analyticsMetadata
    metadata = JSON.parse(metadata)

    window.analytics.track(`${eventName} Clicked - Member Web`, { ...metadata })
  },
}

export const AnalyticsChange = {
  mounted() {
    this.el.addEventListener('change', this.track)
  },
  destroyed() {
    this.el.removeEventListener('change', this.track)
  },
  track(e) {
    let selectedVal
    for (const option of e.target.selectedOptions) {
      selectedVal = option.value
    }

    let eventName = this.dataset.analyticsEvent.trim()
    eventName = toCapitalCase(eventName)

    let metadata = this.dataset.analyticsMetadata
    metadata = JSON.parse(metadata)
    metadata.value = selectedVal

    window.analytics.track(`${eventName} Clicked - Member Web`, { ...metadata })
  },
}

export const AnalyticsPage = {
  additionalAnalytics() {
    const additonalData = this.el.dataset.analyticsMetadata
    return additonalData ? JSON.parse(additonalData) : {}
  },
  pageName() {
    return this.el.dataset.analyticsPageName.trim()
  },
  mounted() {
    const eventName = toCapitalCase(this.pageName())
    window.analytics.page(`${eventName} Page Viewed - Member Web`, {
      height: window.innerHeight,
      width: window.innerWidth,
      zoomScale: calculateZoom(),
      ...pageDetails(),
      ...this.additionalAnalytics(),
    })
  },
}

export const AnalyticsIdentify = {
  mounted() {
    if (window.MEMBER_ID) {
      const traits = convertMapKeysFromSnakeToCamelCase(
        JSON.parse(window.TRAITS.replace(/&quot;/g, '"')),
      )

      window.analytics.identify(window.MEMBER_ID, traits)
    }
  },
}

const pageDetails = () => {
  const REGEX_EXTRACT_ID = /visits(\/\w+)/gi
  const { search, pathname, href } = window?.location ?? {}
  const { title } = document

  const redactable = [pathname, href, document.referrer]
  const [path, url, referrer] = redactable.map(val =>
    val.replace(REGEX_EXTRACT_ID, 'visits/:REDACTED_VISIT_TOKEN'),
  )
  return { path, referrer, search, title, url }
}

/* --- Helpers --- */
const toCapitalCase = sentence =>
  sentence
    .split(' ')
    .map(word => capitalizeFirstLetter(word))
    .join(' ')

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)

export default { AnalyticsIdentify, AnalyticsPage, AnalyticsChange, AnalyticsClick }
